import { createStyles, Theme } from '@material-ui/core/styles';
import * as color from 'color';

const styles: any = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 10000,
      backgroundColor: color(theme.palette.common.white)
        .alpha(0.37)
        .rgb()
        .string()
    },
    label: {
      color: theme.palette.text.secondary
    }
  });

export default styles;
